import pl_translation from "./translations/pl.js"
import en_translation from "./translations/en.js"


const messages = {
  pl: pl_translation,
  en: en_translation
}

export default messages;



// WEBPACK FOOTER //
// ./src/lang.js